import { apiCall, API_CONFIG } from './api';

export const monitoringAPI = {
  getMonitoringLogs: async (page = 1, limit = 20, dateFilter = 'today', startDate = '', endDate = '') => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      queryParams.append('dateFilter', dateFilter);

      if (dateFilter === 'custom') {
        if (startDate) queryParams.append('startDate', startDate);
        if (endDate) queryParams.append('endDate', endDate);
      }

      const rawBaseUrl = process.env.REACT_APP_MONITORING_API_BASE_URL || 'http://142.93.211.8:5009/api';
      const baseUrl = rawBaseUrl.replace(/\/+$/, '');
      const url = `${baseUrl}${API_CONFIG.ENDPOINTS.MONITORING_LOGS}?${queryParams.toString()}`;
      const response = await apiCall(url, {
        method: 'GET',
      });

      if (response.success) {
        return {
          success: true,
          logs: response.data?.logs || [],
          pagination: response.data?.pagination || {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            limit: 20
          },
          msg: response.msg
        };
      } else {
        return {
          success: false,
          logs: [],
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            limit: 20
          },
          message: response.msg || 'Failed to fetch monitoring logs'
        };
      }
    } catch (error) {
      console.error('Error fetching monitoring logs:', error);
      return {
        success: false,
        logs: [],
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          limit: 20
        },
        message: error.message || 'Network error occurred'
      };
    }
  }
};
